/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ProjectLegacy } from 'src/app/app-data/models/Project';
import { FancyFirebaseObject } from '../base/FancyFirebaseObject';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';

export class ProjectObject extends FancyFirebaseObject<ProjectLegacy> {
	constructor(angularLand: AngularLandConnection, path: RefOrObservable) {
		super(angularLand, path);
	}

	public $$updated(child: any) {
		if (!child || !child.payload.exists()) {
			return null;
		}
		return new ProjectLegacy(child.payload.val());
	}
}
